export const requestContractPath = "request-contract";
export const contractsPath = "contracts";
export const documentsPath = "documents";
export const userManagementPath = "user-mgmt";
